export default __webpack_public_path__ + "static/media/card-w-press.92c92994.png";